import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr'
import {
  FLAG_GETTING_LEGAL_MANIFEST_TICKETS,
  GET_LEGAL_MANIFEST_TICKETS,
  CLEAR_LEGAL_MANIFEST_TICKETS
} from '../types'
import { isErrorResponse } from '../../utils/error-handlers';
import { DEFAULT_GET_CONFIG } from '../../config/rest';
import { LEGAL_MANIFEST_TICKET_ENDPOINT } from '../../config/endpoints';
import { printManifest } from '../../utils/printers/Manifest';
import { getManifest } from '../itinerary';

const flagGettingManifestTickets = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_LEGAL_MANIFEST_TICKETS,
    payload: flag
  });

const clearLegalManifestTickets = () => (dispatch) =>
  dispatch({
    type: CLEAR_LEGAL_MANIFEST_TICKETS
  });

const getLegalManifestTickets = async (filters) => async (dispatch) => {
  try {
    dispatch(flagGettingManifestTickets(true));
    const query = filters;
    const url = `${LEGAL_MANIFEST_TICKET_ENDPOINT}?${QueryString.stringify(query)}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const legalManifestTickets = await response.json();
    dispatch({
      type: GET_LEGAL_MANIFEST_TICKETS,
      payload: legalManifestTickets
    });
  } catch (error) {
    toastr.error('Error', error.message);
  }
  finally {
    dispatch(flagGettingManifestTickets(false));
  }
}

const getLegalManifestTicketDetail = async (params) => async () => {
  try {
    const query = QueryString.stringify(params);
    const url = `${LEGAL_MANIFEST_TICKET_ENDPOINT}/detail?${query}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    const legalManifestTicketDetail = await response.json();
    return legalManifestTicketDetail;
  } catch (error) {
    toastr.error('Error', error.message);
    return [];
  }
}


const getManifestTicketExportExcel =
  async (idSourceSystem) =>
    async (dispatch) => {
      try {
        dispatch(flagGettingManifestTickets(true));
        const url = `${LEGAL_MANIFEST_TICKET_ENDPOINT}/${idSourceSystem}/actions/export-excel`;
        const response = await fetch(url, DEFAULT_GET_CONFIG);
        await isErrorResponse(response);
        const blob = await response.blob();
        const downloadUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = "MANIFESTO_TICKET";
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        toastr.error('Error', error.message);
      } finally {
        dispatch(flagGettingManifestTickets(false));
      }
    };

const generateManifestTicketFile = async (itineraryId) => async (dispatch) => {
  try {
    dispatch(flagGettingManifestTickets(true));
    const manifest = await dispatch(getManifest({
      itineraryId,
    }));
    if (manifest) {
      printManifest(manifest);
    }
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagGettingManifestTickets(false));
  }
}


export {
  flagGettingManifestTickets,
  getLegalManifestTickets,
  clearLegalManifestTickets,
  getManifestTicketExportExcel,
  getLegalManifestTicketDetail,
  generateManifestTicketFile
};
